import { Route } from '@angular/router';
import { CanViewReportsGuard } from '../../../../../auth/routing/guards';

import { BidAnalysisReportComponent } from '../../../../pages/bid-analysis-report/bid-analysis-report.component';
import { BidFeeReportComponent } from '../../../../pages/bid-fee-report/bid-fee-report.component';
import { TenderReportComponent } from '../../../../pages/tender-report';
import { TenderReportsComponent } from '../../../../pages/tender-reports';
import { SealedTenderGuard } from '../../../guards';
import { TenderAnalyticsConversionFactorResolver, TenderUnitRatesResolver } from '../../../resolvers';

export const tenderReportsRoute: Route = {
    path: 'reports',
    component: TenderReportsComponent,
    children: [
        {
            path: '',
            redirectTo: 'bid-analysis',
            pathMatch: 'full',
        },
        {
            path: 'year-over-year',
            component: TenderReportComponent,
            canActivate: [CanViewReportsGuard],
        },
        {
            path: 'bid-analysis',
            component: BidAnalysisReportComponent,
            canActivate: [SealedTenderGuard],
            resolve: {
                tenderSettings: TenderAnalyticsConversionFactorResolver,
                unitRates: TenderUnitRatesResolver,
            },
        },
        {
            path: 'bid-fee',
            component: BidFeeReportComponent,
            canActivate: [SealedTenderGuard],
            resolve: {
                tenderSettings: TenderAnalyticsConversionFactorResolver,
                unitRates: TenderUnitRatesResolver,
            },
        },
    ],
};
